import { render, staticRenderFns } from "./Protector.vue?vue&type=template&id=826c5960&scoped=true"
import script from "./Protector.vue?vue&type=script&lang=js"
export * from "./Protector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826c5960",
  null
  
)

export default component.exports